import { render, staticRenderFns } from "./uploadExames.vue?vue&type=template&id=48f2d026&scoped=true"
import script from "./uploadExames.vue?vue&type=script&lang=js"
export * from "./uploadExames.vue?vue&type=script&lang=js"
import style0 from "./uploadExames.vue?vue&type=style&index=0&id=48f2d026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2d026",
  null
  
)

export default component.exports